export { default } from './bank-offers';
